const TransactionStatusEnum = {
  SALE: "sale",
  REFUND: "refund",
  VOID: "void",
};

export default TransactionStatusEnum;
